module.exports = __webpack_public_path__ + "static/media/Pasta.ce2e02b2.m4a";